const DURATION = 2000;

class MinerwaStats extends HTMLElement {
  connectedCallback() {
    this.counters = [...this.querySelectorAll('[data-counter]')];
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.dataset.revealed = 'true';
        this.counters.forEach((el) => this.count(el));
        this.observer.disconnect();
      },
      { threshold: 0.1 },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  count(el) {
    const target = Number(el.dataset.value);
    if (Number.isNaN(target)) return;
    const decimals = target % 1 === 0 ? 0 : 1;
    let start = null;

    const step = (timestamp) => {
      if (start === null) start = timestamp;
      const progress = Math.min((timestamp - start) / DURATION, 1);
      const eased = 1 - Math.pow(1 - progress, 4);
      el.textContent = decimals === 0
        ? String(Math.floor(eased * target))
        : (eased * target).toFixed(1);
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = decimals === 0 ? String(target) : target.toFixed(1);
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = decimals === 0 ? String(target) : target.toFixed(1);
      return;
    }
    requestAnimationFrame(step);
  }
}

if (!customElements.get('minerwa-stats')) {
  customElements.define('minerwa-stats', MinerwaStats);
}
